module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "list-item"
  }, [_c('menu-vertical', {
    attrs: {
      "path": _vm.path
    }
  }, [_c('span', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "padding-right": "20px"
    },
    attrs: {
      "slot": "dock"
    },
    slot: "dock"
  }, [_c('bo-switch', {
    ref: "sw",
    attrs: {
      "state": _vm.state
    },
    on: {
      "on-click": _vm._handleSwitch
    }
  })], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4ce97d9b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demohelper/demoswitch.vue
// module id = 35
// module chunks = 9 10 18